import React from "react";
import AccountNavigationModal from "../../../screens/UserAccount/AccountNavigationModal";

const UserAccount = ({onClose}) => {
    return <AccountNavigationModal onClose={onClose}/>
}

export default UserAccount